module.exports = __webpack_public_path__ + "media/layout-dark.2d4313f6.mp4";